export enum FeatureToggleScopeEnum {
  Global = 1,
  Partner = 2,
  Organization = 4,
  Campaign = 6,
  User = 8,
}

/** Backend DTO shape (PascalCase) */
export type FeatureFlagRawItemType = {
  ID: string;
  IsEnabled: boolean;
  Description: string;
  Scope: FeatureToggleScopeEnum;
  CreatedAt: string;
  UpdatedAt: string;
};

/** Normalized frontend shape (camelCase) */
export type FeatureFlagItemType = {
  id: string;
  isEnabled: boolean;
  description: string;
  scope: FeatureToggleScopeEnum;
  createdAt: string;
  updatedAt: string;
};

export type FeatureFlagSaveItemType = {
  Name: string;
  isEnabled: boolean;
  scope: FeatureToggleScopeEnum;
};

export const normalizeFlagItem = (item: FeatureFlagRawItemType): FeatureFlagItemType => ({
  id: item.ID,
  isEnabled: item.IsEnabled,
  description: item.Description ?? '',
  scope: item.Scope,
  createdAt: item.CreatedAt,
  updatedAt: item.UpdatedAt,
});
